import React__default from 'react';
import '../../utils/index.js';
import { ChildIndexProvider, useChildIndex } from '../../components/Dropdown/ChildIndexContext/index.js';
import createContextUtilities from '../../utils/createContextUtilities/createContextUtilities.js';

const {
  useContext: useMenuContext,
  Provider: MenuContextProvider
} = createContextUtilities();
const {
  useContext: useItemContext,
  Provider: ItemContextProvider
} = createContextUtilities({});
const {
  useContext: intermediaryUseMenuContext,
  Provider: IntermediaryMenuContextProvider
} = createContextUtilities();
const PaneContextProvider = _ref => {
  let {
    items,
    setItems,
    value,
    children
  } = _ref;
  return /*#__PURE__*/React__default.createElement(ChildIndexProvider, {
    items: items,
    setItems: setItems
  }, /*#__PURE__*/React__default.createElement(IntermediaryMenuContextProvider, {
    value: value
  }, children));
};
const usePaneContext = childItemRef => {
  const coreContext = intermediaryUseMenuContext();
  const childIndex = useChildIndex({
    element: childItemRef
  });
  return {
    childIndex,
    ...coreContext
  };
};

export { ItemContextProvider, MenuContextProvider, PaneContextProvider, useItemContext, useMenuContext, usePaneContext };
